export default function OfficesSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
            グローバル拠点
          </h2>
          <p className="text-sm text-foreground-500 tracking-[0.08em] font-sans font-light">
            世界4拠点で24時間365日監視
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {/* Tokyo HQ */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20photography%20of%20a%20modern%20Japanese%20corporate%20headquarters%20office%20in%20Tokyo%20Marunouchi%2C%20minimalist%20design%20with%20warm%20wood%20desks%2C%20floor%20to%20ceiling%20windows%20overlooking%20cityscape%2C%20clean%20organized%20workspace%2C%20natural%20daylight%2C%20premium%20corporate%20atmosphere%2C%20empty%20office%2C%20no%20people%2C%20high-end%20Japanese%20aesthetic&width=600&height=800&seq=office-tokyo-hq&orientation=portrait"
                alt="東京本社"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">
                  本社
                </span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">東京本社</h3>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">東京都千代田区丸の内1-5-1</p>
              <p className="text-xs text-foreground-400 tracking-[0.05em] font-sans font-light">TEL: 03-5215-8420</p>
            </div>
          </div>

          {/* Osaka */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20photography%20of%20a%20modern%20Japanese%20corporate%20office%20in%20Osaka%20Umeda%2C%20minimalist%20industrial%20design%2C%20glass%20partition%20walls%2C%20open%20plan%20layout%2C%20warm%20ambient%20lighting%2C%20clean%20desks%20with%20monitors%2C%20city%20view%20from%20window%2C%20empty%20office%2C%20no%20people%2C%20professional%20atmosphere&width=600&height=800&seq=office-osaka-branch&orientation=portrait"
                alt="大阪支社"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">
                  支社
                </span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">大阪支社</h3>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">大阪府大阪市北区梅田2-2-2</p>
              <p className="text-xs text-foreground-400 tracking-[0.05em] font-sans font-light">TEL: 06-6345-8700</p>
            </div>
          </div>

          {/* Fukuoka */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20photography%20of%20a%20modern%20Japanese%20tech%20office%20in%20Fukuoka%20Hakata%2C%20clean%20white%20walls%20with%20wood%20accents%2C%20collaborative%20workspace%2C%20large%20monitors%20on%20desks%2C%20indoor%20plants%2C%20bright%20natural%20lighting%20from%20windows%2C%20empty%20office%20space%2C%20no%20people%2C%20modern%20minimal%20aesthetic&width=600&height=800&seq=office-fukuoka-center&orientation=portrait"
                alt="福岡センター"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">
                  センター
                </span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">福岡センター</h3>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">福岡県福岡市博多区博多駅前3-4-1</p>
              <p className="text-xs text-foreground-400 tracking-[0.05em] font-sans font-light">TEL: 092-432-5600</p>
            </div>
          </div>

          {/* Singapore */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20photography%20of%20a%20modern%20corporate%20office%20in%20Singapore%20Raffles%20Place%2C%20glass%20walls%20with%20skyline%20view%2C%20minimalist%20furniture%2C%20tropical%20indoor%20plants%2C%20clean%20white%20and%20wood%20interior%2C%20bright%20daylight%2C%20empty%20office%2C%20no%20people%2C%20international%20business%20atmosphere&width=600&height=800&seq=office-singapore&orientation=portrait"
                alt="シンガポール事務所"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">
                  海外拠点
                </span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">シンガポール事務所</h3>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">1 Raffles Place, Singapore 048616</p>
              <p className="text-xs text-foreground-400 tracking-[0.05em] font-sans font-light">TEL: +65-6325-7800</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}